import { useTranslation } from 'react-i18next';

import BlogAuthorThumbnail from '@klv/molecules/blog-author-thumbnail';
import BlogCategoryButton from '@klv/molecules/blog-category-button';
import TranslatedDate from '@klv/atoms/translated-date';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/blogArticleArchiveHero.module.scss';

import type { IBlogArticleArchiveHero } from './types';

const BlogArticleArchiveHero = ({
  authors,
  category,
  categoryArchive = false,
  className,
  date,
  description = '',
  displayAuthorDate,
  headline,
  image,
  isPage,
  layout = 'one',
  readTime,
  ...props
}: IBlogArticleArchiveHero) => {

  const { t } = useTranslation();

  /* 
    If we're on an editorial PAGE (not a what's new blog post post) with a category of 
    "What's New" this will ensure the category link points to the correct URL.
  */
  if (isPage && category?.link) {
    category.link = category.link.replace('/blog/category/whats-new', '/product/whats-new');
  }

  return (
  <div className={generateClassName(['grid', styles.blogArticleHero, layout === 'two' && styles.layoutTwo, className])} {...props}>
    <div className={generateClassName([styles.textContainer, categoryArchive && styles.categoryArchive])}>
      <h1 className={generateClassName(['h2', 'semiBold'])}>
        {headline}
      </h1>
      {description && (
        <p 
          className={generateClassName(['paragraph1', styles.description])}
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
      {displayAuthorDate && 
        <div className={styles.blogAuthorThumbnailContainer}>
          {authors && 
            <BlogAuthorThumbnail
              authors={authors}
              readTime={readTime}
            />
          }
        </div>
      }
      {category && (
        <BlogCategoryButton
          afterText={displayAuthorDate && <TranslatedDate date={date} options={{
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }}/>}
          link={category.link}
          name={category.name}
        />
      )}
    </div>

    {image && (
      <img
        alt={image.altText || `${t('organisms_blogArticleHero_featureImageAltText')}`}
        className={styles.heroImage}
        height={image?.mediaDetails?.height}
        src={image?.sourceUrl}
        srcSet={image?.srcSet}
        width={image?.mediaDetails?.width}
        loading="eager"
      />
    )}
  </div>
  );
};

export default BlogArticleArchiveHero;
